import { IDog, IProfile, MessageTemplating } from '@jumpstart/core';
import Grid from '@mui/material/Grid';
import React from 'react';
import ChatBubble from '../../../widgets/ChatBubble';
import { IDailyMessage, ISubscriber } from '../schemas';


const POCKET_SCOUT = `${process.env.PUBLIC_URL}/assets/images/logos/scout9-logo-blue-diamond.png`;
const PROFILE_PLACEHOLDER = `${process.env.PUBLIC_URL}/assets/images/placeholder2.png`;

export interface IMessageView {
  subscriber: ISubscriber;
  message: IDailyMessage;
  dog: IDog;
  profile: IProfile;
}

export default function MessageView(props: IMessageView) {
  const { message, dog, profile, subscriber } = props;

  if (message.replies) {
    return (
      <Grid
        container
        direction="column"
        sx={{
          '& > :not(:last-child)': {
            marginBottom: 3
          }
        }}
      >
        {
          message.replies.map(({ category, date, reply, prompt }) => <React.Fragment>
              {prompt ?
                <ChatBubble
                  key={prompt}
                  body={MessageTemplating.process(prompt, dog, profile)}
                  direction="right"
                  avatar={{src: POCKET_SCOUT}}
                  date={date}
                /> : null}
              {reply ?
                <ChatBubble
                  key={reply}
                  body={reply}
                  direction="left"
                  date={date}
                  avatar={{src: PROFILE_PLACEHOLDER}}/> : null}
            </React.Fragment>
          )
        }
        {message.dialog.body ?
          <ChatBubble
            body={MessageTemplating.process(message.dialog.body ? message.dialog.body : '', dog, profile)}
            direction="right"
            avatar={{src: POCKET_SCOUT}}
            date={message.date}
          /> : null}
      </Grid>
    );
  } else {
    return (
      <Grid
        container
        direction="column"
        sx={{
          '& > :not(:last-child)': {
            marginBottom: 3
          }
        }}
      >
        {message.dialog.body ?
          <ChatBubble
            body={MessageTemplating.process(message.dialog.body ? message.dialog.body : '', dog, profile)}
            direction="right"
            avatar={{src: POCKET_SCOUT}}
            date={message.date}
          /> : null}
      </Grid>
    );
  }
}
